import ReactCompatibility from './react-compatibility';

const DownloadOverlayManager = {};

DownloadOverlayManager.show = () => {
  // OnboardingTour is not running or it will not be triggered
  if (typeof window.checkForExportCookieIntervalCleared === 'undefined' || window.checkForExportCookieIntervalCleared) {
    ReactCompatibility.showDownloadOverlay();
  } else {
  // OnboardingTour is running. Need to wait for checkForExportCookieIntervalId to be cleared
    const checkForExportCookieIntervalId = setInterval(() => {
      if (window.checkForExportCookieIntervalCleared) {
        clearInterval(checkForExportCookieIntervalId);

        if ($('.saveButton').length > 0) {
          $('.saveButton').button('reset');
          document.querySelector('.saveButton').classList.remove('active');
        }

        if ($('.onboardingModal').hasClass('in')) {
          $('.onboardingModal').on('hidden', () => {
            ReactCompatibility.showDownloadOverlay();
          });
        } else {
          ReactCompatibility.showDownloadOverlay();
        }
      }
    }, 500);
  }
};

export default DownloadOverlayManager;



// WEBPACK FOOTER //
// ./src-assets/js/download-overlay-manager.js